import { render, staticRenderFns } from "./RecipeTable.vue?vue&type=template&id=8ef087cc&scoped=true"
import script from "./RecipeTable.vue?vue&type=script&lang=js"
export * from "./RecipeTable.vue?vue&type=script&lang=js"
import style0 from "./RecipeTable.vue?vue&type=style&index=0&id=8ef087cc&prod&scoped=true&lang=css"
import style1 from "./RecipeTable.vue?vue&type=style&index=1&id=8ef087cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef087cc",
  null
  
)

export default component.exports